import { IsBoolean } from "class-validator";

export class EmailReportResult {
    @IsBoolean()
    success: boolean
}